import {
    Award,
    BarChart3,
    Bell,
    Bookmark,
    Box,
    Boxes,
    Briefcase,
    Building2,
    Calendar,
    CheckSquare,
    ClipboardList,
    Clock,
    Contact,
    CreditCard,
    DollarSign,
    FileText,
    Flag,
    Folder,
    Gift,
    Globe,
    GraduationCap,
    Handshake,
    Heart,
    Home,
    Layers,
    Lightbulb,
    MapPin,
    Mail,
    Megaphone,
    Package,
    Phone,
    PieChart,
    Receipt,
    Rocket,
    Settings,
    ShoppingCart,
    Star,
    Tag,
    Target,
    Ticket,
    TrendingUp,
    Truck,
    User,
    UserPlus,
    Users,
    Wrench,
    Zap,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Curated icon set for modules. Keys are stored verbatim in `module.icon`, so
 * the names must stay stable. `getModuleIcon` resolves a stored name back to a
 * component (falling back to a generic box).
 */
export const MODULE_ICONS: Record<string, LucideIcon> = {
    Boxes,
    Box,
    Layers,
    Package,
    Folder,
    Users,
    User,
    UserPlus,
    Contact,
    Building2,
    Briefcase,
    Handshake,
    Target,
    TrendingUp,
    BarChart3,
    PieChart,
    DollarSign,
    CreditCard,
    Receipt,
    ShoppingCart,
    Gift,
    Ticket,
    CheckSquare,
    ClipboardList,
    FileText,
    Bookmark,
    Tag,
    Flag,
    Calendar,
    Clock,
    Bell,
    Mail,
    Phone,
    Globe,
    MapPin,
    Home,
    Truck,
    Wrench,
    Settings,
    Star,
    Heart,
    Award,
    Rocket,
    Lightbulb,
    Megaphone,
    Zap,
    GraduationCap,
};

export const MODULE_ICON_NAMES = Object.keys(MODULE_ICONS);

/** Resolve a stored icon name to its component (fallback: Boxes). */
export function getModuleIcon(name?: string | null): LucideIcon {
    return (name && MODULE_ICONS[name]) || Boxes;
}

/**
 * Preset module accent colors — vibrant mid-tones chosen to stay legible in
 * both light and dark mode (no near-black/near-white). The custom-color input
 * still allows any hex.
 */
export const MODULE_COLORS = [
    '#3B82F6',
    '#6366F1',
    '#8B5CF6',
    '#A855F7',
    '#EC4899',
    '#F43F5E',
    '#EF4444',
    '#F97316',
    '#F59E0B',
    '#EAB308',
    '#84CC16',
    '#10B981',
    '#14B8A6',
    '#06B6D4',
    '#0EA5E9',
    '#64748B',
];

export const DEFAULT_MODULE_COLOR = MODULE_COLORS[0];
